import some from 'lodash/some';
import { RouteComponentProps } from 'react-router';
import { SCROLLABLE_PATHS } from '../constants/main';

export const getIndependentScrolling = (
    location?: RouteComponentProps<any, any>['location'],
) => {
    let independentScrolling = false;
    const pathname = location?.pathname;

    if (pathname) {
        independentScrolling = some(
            SCROLLABLE_PATHS,
            (path) => pathname.indexOf(path) > -1,
        );
    }

    return independentScrolling;
};
